const Actions = () => {
  return (
    <div>
      <div>
        <h1 className="text-xl leading-9">Entries</h1>
      </div>
      <div className="flex items-center justify-between mt-5">
        <div className="flex items-center">
          <div>
            <button
              className="flex items-center border border-gray-400	rounded py-1.5 px-3"
              type="button"
            >
              <span className="px-1">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.75 4.25H11.25"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M10.25 1.5H1.75C1.19772 1.5 0.75 1.94772 0.75 2.5V10.25C0.75 10.8023 1.19772 11.25 1.75 11.25H10.25C10.8023 11.25 11.25 10.8023 11.25 10.25V2.5C11.25 1.94772 10.8023 1.5 10.25 1.5Z"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M3.25 2.75V0.5"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M8.75 2.75V0.5"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                </svg>
              </span>

              <span className="text-sm px-2"> 07/02/2022 - 13/02/2022 </span>
            </button>
          </div>
          <div>
            <div className="ml-3">
              <label className="relative block">
                <span className="sr-only">Search</span>
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.21879 9.21873L6.64941 6.64935"
                      stroke="#848484"
                      strokeMiterlimit="10"
                    />
                    <path
                      d="M4.21875 7.65625C6.11723 7.65625 7.65625 6.11723 7.65625 4.21875C7.65625 2.32027 6.11723 0.78125 4.21875 0.78125C2.32027 0.78125 0.78125 2.32027 0.78125 4.21875C0.78125 6.11723 2.32027 7.65625 4.21875 7.65625Z"
                      stroke="#848484"
                      strokeMiterlimit="10"
                    />
                  </svg>
                </span>
                <input
                  type="text"
                  placeholder="Search"
                  className="py-1.5 pl-8 focus:pr-10 focus:outline-none rounded-md bg-[#F4F4F4] "
                />
              </label>
            </div>
          </div>
        </div>
        <div className="flex items-center">
          <div className="mx-4">
            <button
              className="flex items-center border hover:bg-[#F4F4F4] border-gray-400	rounded py-1.5 px-3"
              type="button"
            >
              <span className="px-1">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.25 1.875H0.625"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M9.37533 1.875H4.79199"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M3.54199 3.125C4.23235 3.125 4.79199 2.56536 4.79199 1.875C4.79199 1.18464 4.23235 0.625 3.54199 0.625C2.85164 0.625 2.29199 1.18464 2.29199 1.875C2.29199 2.56536 2.85164 3.125 3.54199 3.125Z"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M9.375 5H8.75"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M5.20833 5H0.625"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M6.45801 6.25C7.14836 6.25 7.70801 5.69036 7.70801 5C7.70801 4.30964 7.14836 3.75 6.45801 3.75C5.76765 3.75 5.20801 4.30964 5.20801 5C5.20801 5.69036 5.76765 6.25 6.45801 6.25Z"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M1.25 8.125H0.625"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M9.37533 8.125H4.79199"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M3.54199 9.375C4.23235 9.375 4.79199 8.81536 4.79199 8.125C4.79199 7.43464 4.23235 6.875 3.54199 6.875C2.85164 6.875 2.29199 7.43464 2.29199 8.125C2.29199 8.81536 2.85164 9.375 3.54199 9.375Z"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                  />
                </svg>
              </span>
              <span className="text-sm px-1">Filter</span>
            </button>
          </div>
          <div className="ml-4">
            <button
              className="flex items-center bg-[#3989DD] border text-white rounded-lg py-1.5 px-3 hover:shadow-lg"
              type="button"
            >
              <span className="px-1 pl-2">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_371_37)">
                    <path
                      d="M6 0.5625V7.875"
                      stroke="white"
                      strokeMiterlimit="10"
                    />
                    <path
                      d="M4.125 2.4375L6 0.5625L7.875 2.4375"
                      stroke="white"
                      strokeMiterlimit="10"
                    />
                    <path
                      d="M7.5 4.875H9.375C9.62364 4.875 9.8621 4.97377 10.0379 5.14959C10.2137 5.3254 10.3125 5.56386 10.3125 5.8125V10.5C10.3125 10.7486 10.2137 10.9871 10.0379 11.1629C9.8621 11.3387 9.62364 11.4375 9.375 11.4375H2.625C2.37636 11.4375 2.1379 11.3387 1.96209 11.1629C1.78627 10.9871 1.6875 10.7486 1.6875 10.5V5.8125C1.6875 5.56386 1.78627 5.3254 1.96209 5.14959C2.1379 4.97377 2.37636 4.875 2.625 4.875H4.5"
                      stroke="white"
                      strokeMiterlimit="10"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_371_37">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>

              <span className="text-base px-1.5">Export Transactions</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Actions;
